{
  "viriyah": {
    "term-condition-page": {
      "title": "ข้อตกลงและเงื่อนไขการใช้บริการ",
      "description": "<p><span class='tab'></span>Line Official Account @viriyah เป็นบริการของวิริยะประกันภัย เพื่อให้บริการข้อมูลการประกันภัยต่อประชาชน โดยผู้ใช้บริการตกลงยินยอมผูกพันตามข้อตกลงและเงื่อนไขการใช้บริการ Line Official Account  @viriyah ทั้งหมด</p><p><span class='tab'></span>ข้อตกลงและเงื่อนไขการใช้บริการ มีดังต่อไปนี้</p><p>1. เงื่อนไขการสมัครใช้บริการ</p><p><span class='tab'></span>ผู้ใช้บริการตกลงยินยอมใช้บริษัทฯ เก็บรวบรวม ใช้ และ/หรือเปิดเผยข้อมูลส่วนบุคคล และ/หรือข้อมูลใดๆ ของผู้ใช้บริการที่ได้ให้ไว้หรือมีอยู่กับบริษัทฯ หรือที่บริษัทฯได้รับหรือเข้าถึงจากระบบนี้หรือแหล่งอื่นตามที่บริษัทฯ มีอำนาจตามกฎหมาย ให้แก่บริษัทประกันภัย หน่วยงานของรัฐ ผู้ให้บริการภายนอก ผู้ประมวลผลข้อมูล ผู้รับโอนสิทธิเรียกร้อง หน่วยงาน องค์กร นิติบุคคลใดๆ ที่มีสัญญากับบริษัทฯ หรือหน่วยงานของรัฐทั้งในประเทศและต่างประเทศ เพื่อวัตถุประสงค์การใช้บริการใดๆตามข้อตกลงนี้ จัดทำข้อมูลสถิติ หรือเพื่อการพัฒนาการให้บริการดิจิทัลต่างๆ เพื่อปฏิบัติตามกฎหมายหรือระเบียบของประเทศใดๆที่ใช้บังคับกับบริษัทฯ</p><p>2. การใช้และการเก็บรักษารหัสประจำตัว</p><p><span class='tab'></span>ผู้ใช้บริการจะควบคุมการใช้งาน จะต้องจัดเก็บรหัสประจำตัวหรือรหัสเข้าสู่ระบบงานของบริษัทฯ หรือรหัสอื่นใดที่บริษัทฯมอบให้ไว้เป็นความลับหรือไม่เปิดเผย หรือกระทำ หรือละเว้นการกระทำใดๆอันเป็นเหตุให้บุคคลอื่นที่ไม่ได้รับอนุญาตได้ล่วงรู้ข้อมูลดังกล่าว หากผู้ใช้บริการไม่ปฏิบัติตามที่กล่าวมาและเป็นเหตุให้เกิดความเสียหาย ผู้ใช้บริการจะต้องรับผิดชอบความเสียหายที่เกิดขึ้นนั้นเอง โดยบริษัทฯไม่ต้องร่วมรับผิดชอบด้วย</p><p><span class='tab'></span>ผู้ใช้บริการอาจตั้งรหัสผ่านในการเข้าดูกรมธรรม์ประกันถัยของตนเองหรือเผยแพร่ให้บุคคลอื่นที่ผู้ใช้บริการประสงค์จะเปิดเผย โดยดำเนินการตามวิธิการและเงื่อนไขที่บริษัทฯกำหนด และอาจเปลี่ยนแปลงรหัสผ่านได้ โดยตกลงให้รหัสผ่านนั้นเป็นรหัสผ่านสำหรับการใช้บริการที่มีผลผูกพันผู้ใช้บริการทุกประการ ผู้ใช้บริการทราบดีว่ารหัสผ่าน เป็นข้อมูลลับเฉพาะซึ่งผู้ใช้บริการจะต้องเก็บรักษาไว้และมิให้บุคคลอื่นใดที่ไม่ได้รับอนุญาตล่วงรู้โดยเด็ดขาด</p><p>3. การใช้บริการ</p><p><span class='tab'></span>ผู้ใช้บริการสามารถสมัครใช้บริการผ่านช่องทาง Line Official Account  @viriyah ของบริษัทฯ ทั้งนี้ ช่องทางใช้งานหรือช่องทางติดต่อของบริษัทฯ อาจมีการเปลี่ยนแปลงได้ในอนาคตโดยบริษัทฯ จะได้แจ้งให้ทราบทาง Website ของบริษัทฯ</p><p>4. การระงับการให้บริการ</p><p><span class='tab'></span>4.1 ผู้ใช้บริการสามารถระงับการใช้บริการได้ด้วยตนเองผ่านช่องทาง Line Official Account  @viriyah ของบริษัทฯ ทั้งนี้ ช่องทางติดต่อ บริษัทฯอาจมีการเปลี่ยนแปลงได้ในอนาคตโดยบริษัทฯจะได้แจ้งให้ทราบทาง Website ของบริษัทฯ</p><p><span class='tab'></span>4.2 บริษัทฯ อาจมีการดำเนินการเฝ้าระวังและตรวจสอบปริมาณการใช้งาน ซึ่งหากมีข้อสงสัยหรือหากผู้ใช้บริการป้อนรหัสผ่านผิดเกินกว่าจำนวนครั้งที่กำหนด บริษัทฯ อาจระงับการให้เข้าใช้บริการชั่วคราว จนกว่าผู้ใช้บริการจะติดต่อมายังบริษัทฯหรือได้รับการตรวจสอบและอนุญาตให้ใช้งานระบบจากบริษัทฯอีกครั้งหนึ่ง ทั้งนี้ บริษัทฯ สงวนสิทธิ์ในการระงับการให้บริการในอนาคตได้ตามที่บริษัทฯเห็นสมควร</p><p>5. การเก็บและเปิดเผยข้อมูลส่วนบุคคล</p><p><span class='tab'></span>ข้อมูลส่วนบุคคลหรือข้อมูลอื่นใดของผู้ใช้บริการจะถูกนำไปใช้ประโยชน์ในการให้บริการตามที่ผู้ใช้บริการร้องขอและตามวัตถุประสงค์และข้อตกลงและเงื่อนไขในการใช้บริการนี้ เช่น</p><p><span class='tab'></span>5.1 ภาพถ่ายบัตรประชาชน จะถูกส่งต่อไป Google Cloud OCR Service เพื่ออ่านข้อมูลภาพ</p><p><span class='tab'></span>5.2 ภาพถ่ายบัตรประจำตัวประชาชนและภาพถ่ายของผู้ใช้บริการ จะถูกรวบรวมและประมวลผล เพื่อใช้ในการตรวจสอบและยืนยันตัวตนของผู้ใช้บริการ</p><p><span class='tab'></span>5.3 เลขประจำตัวประชาชน และเลขเลเซอร์หลังบัตรประชาชน จะถูกเปิดเผยให้กับกรมการปกครอง เพื่อใช้ในการตรวจสอบและยืนยันตัวตนของผู้ใช้บริการ</p><p><span class='tab'></span>5.4 เลขบัตรประจำตัวประชาชน ชื่อ-สกุล ทั้งภาษาไทยและภาษาอังกฤษ รวมถึงเลข 4หลักสุดท้ายของเบอร์โทรศัพท์ จะถูกเปิดเผยให้กับบริษัทฯ  เพื่อให้บริษัทฯส่งข้อมูลกรมธรรม์ประกันภัยของผู้ใช้บริการ</p><p><span class='tab'></span>5.5 เลขบัตรประจำตัวประชาชน และเลขที่กรมธรรม์ประกันภัย จะถูกเปิดเผยให้กับบริษัทฯ ในกรณีที่ผู้ใช้บริการมีความประสงค์จะใช้งานระบบงานอื่นๆของบริษัทฯ</p><p><span class='tab'></span>5.6 ประวัติการจราจรทางคอมพิวเตอร์ จะถูกจัดเก็บรวบรวมและประมวลผลตามที่กำหนดไว้ในกฎหมายว่าด้วยการกระทำความผิดเกี่ยวกับคอมพิวเตอร์โดยสำนักงานหรือบุคคลที่ได้รับมอบหมาย</p><p><span class='tab'></span>นอกจากนี้ ผู้ใช้บริการได้อ่านและทำความเข้าใจนโยบายความเป็นส่วนตัวของบริษัทฯได้ที่ https://www.viriyah.com/information/privacy-policy</p>",
      "check-box-label": "ฉันยินยอมและยอมรับเงื่อนไข",
      "button-confirm": "ตกลง"
    },
    "register-form-page": {
      "title": "กรุณาระบุข้อมูลเพื่อเข้าสู่ระบบ",
      "label-firstName": "ชื่อ",
      "label-lastName": "นามสกุล",
      "label-birthday": "วัน/เดือน/ปีเกิด",
      "label-idCardNumber": "เลขประจำตัวบัตรประชาชน",
      "label-laser": "เลขหลังบัตรประชาชน",
      "label-email": "อีเมล",
      "label-mobileNumber": "เบอร์ติดต่อ",
      "input-placeholder-firstName": "ระบุชื่อ",
      "input-placeholder-lastName": "ระบุนามสกุล",
      "input-placeholder-birthday": "เลือกวัน/เดือน/ปีเกิด",
      "input-placeholder-idCardNumber": "x-xxxx-xxxxx-xx-x",
      "input-placeholder-laser": "xxx-xxxxxxx-xx",
      "input-placeholder-email": "acb@hotmail.com",
      "input-placeholder-mobileNumber": "0xx-xxx-xxxx",
      "button-login": "เข้าสู่ระบบ",
      "notice": "ข้อมูลที่ท่านกรอกเพื่อเข้าสู่ระบบ จะใช้สำหรับพิสูจน์และยืนยันตัวตนเท่านั้น บริษัท ฯ จะไม่บันทึกข้อมูลไว้ในระบบ"
    },
    "otp-page": {
      "title": "โปรดกรอกรหัส OTP เพื่อยืนยันตัวตน",
      "description_1": "รหัส OTP 6 หลักจะถูกส่งไปทาง SMS",
      "description_2": "ที่หมายเลข ",
      "description_3": "รหัสมีอายุใช้งาน 3 นาที ( รหัสอ้างอิง : ",
      "button-confirm": "ยืนยัน",
      "button-renew": "ขอรหัส OTP อีกครั้ง",
      "logo": "<div id='error'><div style='width: 10%;'><img src='https://upload.convolab.ai/viriyah-dev%2Fafce2cc0-3766-43da-bea5-d74abdbebb74.png' id='logo'></div>"
    },
    "login-success-page": {
      "logo": "https://upload.convolab.ai/viriyah-dev%2F128ff645-a49f-4529-8033-3468f182b7dc.png",
      "title": "เข้าสู่ระบบสำเร็จ",
      "description": "<p>คุณสามารถใช้งานบริการต่างๆ <br> หรือดูกรมธรรม์ของคุณได้ผ่านเมนู “กรมธรรม์ของฉัน” <br> กดปุ่มต่อไปเพื่อดำเนินการต่อค่ะ</p>",
      "btn": "ต่อไป"
    },
    "PDPA-page": {
      "title1": "หนังสือยินยอม",
      "title2": "บริษัท วิริยะประกันภัย จำกัด (มหาชน)",
      "assent": "ยินยอม",
      "not-assent": "ไม่ยินยอม",
      "description_1": "ข้าพเจ้ายินยอมให้ บริษัท วิริยะประกันภัย จำกัด (มหาชน) (“บริษัทฯ”) และผู้ควบคุมข้อมูลส่วนบุคคลอื่น ๆ ซึ่งรวมถึงตัวแทน และ/หรือผู้ให้บริการเก็บรวบรวม ใช้และเปิดเผย (“ประมวลผล” หรือ “การประมวลผล”) ข้อมูลส่วนบุคคลทั่วไปของข้าพเจ้า ได้แก่ ชื่อ นามสกุล อายุ อีเมล หมายเลขโทรศัพท์ และข้อมูลอื่นใด ที่ข้าพเจ้าได้ให้ไว้ผ่านช่องทางนี้ หรือให้หมายความรวมถึงข้อมูลที่ระบุในนโยบายคุ้มครองข้อมูลส่วนบุคคลของบริษัทด้วย เพื่อใช้สำหรับดำเนินการเพื่อวัตถุประสงค์ทางการตลาดในการนำเสนอบริการ ข่าวสาร สิทธิประโยชน์ และผลิตภัณฑ์ของทางบริษัท โดยการให้ความยินยอมเพื่อวัตถุประสงค์ข้างต้นนี้ ข้าพเจ้าได้รับทราบว่า การประมวลข้อมูลส่วนบุคคลจะเป็นไปตามรายละเอียดการประมวลผลข้อมูลส่วนบุคคลที่ระบุไว้ใน นโยบายคุ้มครองข้อมูลส่วนบุคคลของบริษัท รวมถึงการใช้สิทธิของเจ้าของข้อมูลส่วนบุคคลผ่านช่องทางต่างๆ ที่บริษัทกำหนดและระบุไว้",
      "description_2": "ข้าพเจ้ารับทราบและให้ความยินยอมหรือปฏิเสธไม่ให้ความยินยอม ในเอกสารนี้ด้วยความสมัครใจ ปราศจากการบังคับหรือชักจูง และข้าพเจ้ารับทราบว่า หากข้าพเจ้าไม่ต้องการรับการสื่อสาร หรือข่าวสาร รวมทั้งสิทธิประโยชน์ใดๆ ที่เกี่ยวกับผลิตภัณฑ์ หรือบริการของบริษัท ข้าพเจ้าสามารถขอเพิกถอนความยินยอมนี้เสียเมื่อใดก็ได้",
      "botton-confirm": "ตกลง"
    },
    "validate-message": {
      "service-error": "ขออภัยค่ะ ขณะนี้ระบบขัดข้อง กรุณาลองใหม่อีกครั้ง",
      "login-form": {
        "firstName": "ชื่อต้องไม่เป็นค่าว่าง",
        "lastName": "นามสกุลต้องไม่เป็นค่าว่าง",
        "idCardNumber": "เลขประจำตัวบัตรประชาชนไม่ถูกต้อง",
        "laser": "เลขหลังบัตรประชาชนไม่ถูกต้อง",
        "email": "อีเมลไม่ถูกต้อง",
        "mobileNumber": "เบอร์ติดต่อไม่ถูกต้อง",
        "logo": "<div id='error'><div style='width: 10%;'><img src='https://upload.convolab.ai/viriyah-dev%2Fafce2cc0-3766-43da-bea5-d74abdbebb74.png' id='logo'></div>"
      },
      "check-dopa": "ข้อมูลที่คุณระบุไม่ถูกต้อง กรุณาตรวจสอบให้ถูกต้องตามข้อมูลในบัตรประชาชนอีกครั้ง",
      "check-my-policy": {
        "error-text": "ไม่พบข้อมูลกรมธรรม์ของคุณในระบบ",
        "link-text": "<div id='error-member-user-link' ><p>กรุณากดติดต่อเจ้าหน้าที่เพื่อตรวจสอบข้อมูลค่ะ</p></div>",
        "no-policy": "ขออภัยค่ะ คุณไม่สามารถลงทะเบียนได้ กรุณาพิมพ์ \"ติดต่อเจ้าหน้าที่\""
      },
      "sign-in": {
        "wrong-employee-code": "ไม่พบรหัสพนักงาน",
        "wrong-mobile-phone-no": "หมายเลขโทรศัพท์มือถือไม่ถูกต้อง",
        "service-error": "ไม่สามารถทำรายการได้ในขณะนี้ โปรดปิดหน้าจอ เพื่อติดต่อเจ้าหน้าที่"
      },
      "otp-alert": {
        "invalid-otp": "รหัส OTP ไม่ถูกต้องหรือหมดอายุ กรุณาทำรายการใหม่อีกครั้ง",
        "repeat-otp": "รหัส OTP ไม่ถูกต้อง โปรดกรอกรหัส OTP ใหม่อีกครั้ง"
      },
      "make-claim": {
        "motorVehicleRegistration": "ทะเบียนรถไม่ถูกต้อง",
        "insuredName": "ชื่อผู้เอาประกันไม่ถูกต้อง",
        "nameTitle": "คำนำหน้าไม่ถูกต้อง",
        "firstName": "ชื่อผู้ขับขี่ไม่ถูกต้อง",
        "lastName": "นามสกุลผู้ขับขี่ไม่ถูกต้อง",
        "incidentLocation": "ตำแหน่งที่เกิดเหตุไม่ถูกต้อง",
        "haveLitigant": "อุบัติเหตุนี้มีคู่กรณีไม่ถูกต้อง",
        "protectionDay": "คุณไม่สามารถแจ้งเคลมกรมธรรม์นี้ได้ค่ะ เนื่องจากวันที่แจ้งเหตุยังไม่อยู่ในช่วงวันคุ้มครองของกรมธรรม์",
        "dateIncident": "ระบุวันที่และเวลาไม่ตรงตามเงื่อนไข กรุณาระบุใหม่อีกครั้งค่ะ",
        "incidentLocationRadio": "ระบุตำแหน่งที่นัดหมายไม่ถูกต้อง"
      }
    },
    "my-policy-page": {
      "motor": {
        "title-pol-type": "ประกันภัยรถยนต์",
        "label-pol-id": "เลขกรมธรรม์",
        "label-pol-cust-name": "ผู้เอาประกัน",
        "label-pol-plateno": "ทะเบียนรถ",
        "label-pol-start-date": "วันที่เริ่มคุ้มครอง",
        "label-pol-end-date": "วันที่หมดอายุ",
        "label-pol-repair-type": "ประเภทการซ่อม",
        "label-pol-status": "สถานะกรมธรรม์",
        "label-pol-due-renew": "ครบกำหนดต่ออายุ",
        "button-pol-renewal": "<button class='btn warn'>ต่ออายุกรมธรรม์*</button>",
        "button-claim": "<button class='btn normal'>แจ้งเคลม</button>",
        "button-copy-pol": "<button class='btn normal'>ขอสำเนากรมธรรม์</button>",
        "description_1": "<p class='description'>กรมธรรม์ของคุณใกล้หมดอายุแล้ว<br>สามารถกดต่ออายุกรมธรรม์เพื่อทำรายการต่อ</p>",
        "description_2": "<p class='description'>กรมธรรม์ของคุณหมดอายุแล้ว<br>สามารถกดต่ออายุกรมธรรม์เพื่อทำรายการต่อ</p>",
        "description_3": "<p class='description'>กรมธรรม์ของคุณหมดอายุแล้ว<br>หากต้องการต่ออายุกรมธรรม์ กรุณาติดเจ้าหน้าที่ค่ะ<br>หรือหากคุณต่ออายุกรมธรรม์แล้วกรุณาตรวจสอบกรมธรรม์เล่มใหม่</p>"
      },
      "AnH": {
        "title-pol-type": "ประกันภัยอุบัติเหตุและสุขภาพ",
        "label-pol-id": "เลขกรมธรรม์",
        "label-pol-cust-name": "ผู้เอาประกัน",
        "label-pol-start-date": "วันเริ่มต้น",
        "label-pol-end-date": "วันสิ้นสุด",
        "label-pol-status": "สถานะกรมธรรม์",
        "label-pol-payment-term": "รูปแบบการชำระ",
        "label-pol-payment-amount": "เบี้ยประกันภัย",
        "label-pol-due-renew": "ครบกำหนดต่ออายุ",
        "button-pol-renewal": "<button class='btn warn'>ต่ออายุกรมธรรม์*</button>",
        "button-claim": "<button class='btn normal'>แจ้งเคลม</button>",
        "button-copy-pol": "<button class='btn normal'>ขอสำเนากรมธรรม์</button>",
        "description_1": "<p class='description'>กรมธรรม์ของคุณใกล้หมดอายุแล้ว<br>สามารถกดต่ออายุกรมธรรม์เพื่อทำรายการต่อ</p>",
        "description_2": "<p class='description'>กรมธรรม์ของคุณหมดอายุแล้ว<br>สามารถกดต่ออายุกรมธรรม์เพื่อทำรายการต่อ</p>",
        "description_3": "<p class='description'>สอบถามข้อมูลเพิ่มเติม กรุณาติดต่อเจ้าหน้าที่</p>"
      }
    },
    "make-claim-page": {
      "validate": {
        "title": "กรุณาตรวจสอบข้อมูลของคุณให้ถูกต้อง",
        "label-motor-vehicle-registration": "ทะเบียนรถ",
        "input-placeholder-motor-vehicle-registration": "ระบุทะเบียนรถ",
        "label-insured-name": "ชื่อผู้เอาประกัน",
        "input-placeholder-insured-name": "ระบุชื่อผู้เอาประกัน",
        "label-driver-name": "ชื่อผู้ขับขี่",
        "input-placeholder-name-title": "คำนำหน้า",
        "input-placeholder-first-name": "ชื่อ",
        "input-placeholder-last-name": "นามสกุล",
        "label-mobileNumber": "เบอร์ติดต่อ",
        "input-placeholder-mobileNumber": "0xx-xxx-xxxx"
      },
      "claim-information": {
        "title": "ระบุข้อมูลสำหรับการแจ้งเคลม",
        "label-date-incident": "ระบุวันที่และเวลาเกิดเหตุ",
        "label-incident-location": "ระบุตำแหน่งที่เกิดเหตุ",
        "label-incident-landmark": "ระบุจุดสังเกตของสถานที่ (ถ้ามี)",
        "label-have-litigant": "อุบัติเหตุนี้มีคู่กรณีหรือไม่",
        "input-placeholder-date-incident": "เลือกวันที่และเวลาเกิดเหตุ",
        "input-placeholder-incident-location": "ระบุตำแหน่งที่เกิดเหตุ",
        "input-placeholder-incident-landmark": "ระบุจุดสังเกตของสถานที่"
      },
      "button-submit": "ส่งข้อมูล",
      "button-next-submit": "ถัดไป",
      "title-alert-off": "หากกดปุ่มปิดด้านบนข้อมูลที่คุณกรอกจะไม่ถูกบันทึก"
    },
    "appointment-claim-information": {
      "title": "ระบุข้อมูลสำหรับการนัดหมายแจ้งเคลม",
      "label-date-incident": "ระบุวันและเวลาที่สะดวกนัดหมาย",
      "label-date-incident-condition": "โดยที่วันนัดหมายต้องไม่เกิน 4 วัน จากวันที่แจ้งเหตุและเวลานัดหมาย อยู่ในช่วง 8.00-16.00 น.",
      "label-appointment-claim": "ระบุตำแหน่งที่นัดหมาย",
      "label-incident-location": "ตำแหน่งเดียวกับจุดเกิดเหตุ",
      "label-new-incident-location": "ระบุตำแหน่งใหม่"
    },
    "make-claim-success-page": {
      "logo": "https://upload.convolab.ai/viriyah-dev%2Fe27e2c63-7653-45b5-97cf-b27038876f03.png",
      "title": "รับเรื่องแจ้งเคลมของคุณเรียบร้อย",
      "description": "<p>ทางเจ้าหน้าที่วิริยะประกันภัย <br> จะติดต่อกลับโดยเร็วค่ะ</p>",
      "btn": "ปิด"
    },
    "postponement-of-claims-page": {
      "title": "ระบุข้อมูลสำหรับการนัดหมายแจ้งเคลม",
      "label-date-incident": "ระบุวันที่และเวลาเกิดเหตุ",
      "label-date-incident-condition": "โดยที่วันนัดหมายต้องไม่เกิน 4 วัน จากวันที่แจ้งเหตุและเวลานัดหมาย อยู่ในช่วง 8.00-16.00 น."
    },
    "postponement-of-claims-success-page": {
      "logo": "https://upload.convolab.ai/viriyah-dev%2F67d71747-ba8e-4e62-b1cf-6f04058ff996.png",
      "title": "รับเรื่องนัดหมายแจ้งเคลมของคุณเรียบร้อย",
      "description": "<p>ทางเจ้าหน้าที่วิริยะประกันภัย <br> จะติดต่อกลับโดยเร็วค่ะ</p>",
      "btn": "ปิด"
    },
    "alert-off-page": {
      "body-top": "ข้อมูลที่คุณกรอกจะไม่ถูกบันทึก",
      "body-bottom": "คุณยืนยันที่จะปิดหน้าต่างหรือไม่",
      "btn-left": "ปิดหน้าต่าง",
      "btn-right": "ทำต่อ"
    }
  }
}
